import type { Component } from '@builder.io/sdk';

export const BuilderVideoConfig: Component = {
  name: '_Video_',
  defaultStyles: {
    height: '100%',
  },
  inputs: [
    {
      name: 'url',
      type: 'string',
    },
    {
      name: 'autoPlay',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'hasControls',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'isLooping',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'isMuted',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'pauseOnViewportLeave',
      type: 'boolean',
      defaultValue: true,
    },
    // playsInline and aspectRatio copied from Builder's built-in Video component
    // https://github.com/BuilderIO/builder/blob/main/packages/react/src/blocks/Video.tsx
    {
      name: 'playsInline',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'aspectRatio',
      type: 'number',
      min: 0,
    },
    {
      name: 'scale',
      type: 'number',
    },
  ],
};
